<script>
    export let href;
    export let icon;
    export let animActivated;
    export let animDefault;
</script>

<style>
    a {
        color: black;
    }
    a:hover {
        text-decoration: none;
    }
    .item {
        display: flex;
        justify-content: space-between;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
    .item:hover {
        background-color: #ddd;
    }
    .anim {
        background-image: var(--img-default);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 25%;
    }
    .item:hover .anim {
        background-image: var(--img-activated);
    }
    .body {
        width: 50%;
    }
    h4 {
        letter-spacing: 0.05em;
        text-transform: uppercase;
        margin: 0;
        font-size: 1.25rem;
    }
    .desc {
        font-size: 0.75rem;
        text-transform: uppercase;
    }
    img {
        width: 3.5rem;
    }
</style>

<a href="{href}">
    <div class="item box lev1">
        <img src="{icon}" alt="icon">
        <div class="body">
            <h4><slot name="name"></slot></h4>
            <div class="desc"><slot name="desc"></slot></div>
        </div>
        <div class="anim"
            style="--img-default: url({animDefault}); --img-activated: url({animActivated});"></div>
    </div>
</a>